export default "__VITE_ASSET__BdLNt_QS__"